import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative pt-24 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1551288049-bebda4e38f71" 
          alt="Financial Analytics"
          className="w-full h-full object-cover opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-gray-50 opacity-95"></div>
      </div>

      {/* Floating Elements */}
      <div className="absolute top-20 right-10 w-64 h-64 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
      <div className="absolute bottom-20 left-10 w-64 h-64 bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center space-y-8 py-12">
          <div className="space-y-4">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-blue-900 tracking-tight animate-fadeInUp">
              More Than Numbers.
            </h1>
            <p className="text-xl sm:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              OUR KEY TO SUCCESS
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mt-16 max-w-6xl mx-auto">
            <div className="group bg-white/80 backdrop-blur-sm p-8 rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-blue-200 transform hover:-translate-y-2">
              <div className="mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_6ea43fd1-5285-4529-ac47-50204ab809b3/artifacts/pgpwnk4t_p9ho3u92_shutterstock_613671434-r.jpg" 
                  alt="Customized Solutions"
                  className="w-full h-40 object-cover rounded-lg mb-4 group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-lg font-semibold text-blue-900 mb-4">
                Customized Solutions
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Financial & accounting environments tailored to your unique business needs. Prioritizing secure & reliable solutions for financial security & business success.
              </p>
            </div>

            <div className="group bg-white/80 backdrop-blur-sm p-8 rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-blue-200 transform hover:-translate-y-2">
              <div className="mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_6ea43fd1-5285-4529-ac47-50204ab809b3/artifacts/g4e0q0zj_xvdjloe8_shutterstock_227930497-r.jpg" 
                  alt="Expert Support"
                  className="w-full h-40 object-cover rounded-lg mb-4 group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-lg font-semibold text-blue-900 mb-4">
                Expert Support
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Our team of finance and accounting experts offers personalized support to help you make informed business decisions and achieve your financial goals.
              </p>
            </div>

            <div className="group bg-white/80 backdrop-blur-sm p-8 rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-blue-200 transform hover:-translate-y-2">
              <div className="mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_6ea43fd1-5285-4529-ac47-50204ab809b3/artifacts/no29wqca_171ynlsx_shutterstock_431851042-r.jpg" 
                  alt="Data-Driven Strategies"
                  className="w-full h-40 object-cover rounded-lg mb-4 group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <h3 className="text-lg font-semibold text-blue-900 mb-4">
                Data-Driven Strategies
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Harness the power of data with our expert analytics tools and techniques. We develop data-driven strategies that help you achieve your goals.
              </p>
            </div>
          </div>

          <button
            onClick={scrollToContact}
            className="inline-flex items-center space-x-2 bg-blue-900 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-800 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 mt-8"
          >
            <span>Contact Us to Learn More</span>
            <ArrowRight size={20} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;